import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { ButtonComponent } from 'mbs-ui-kit';
import { HelpLinkPipe } from 'mbs-ui-shared@help/helpLink.pipe';
import { BrandsModalComponent } from './brands-modal/brands-modal.component';
import { DownloadBuildComponent } from './download-build.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonComponent,
    ReactiveFormsModule,
    NgbDropdownModule,
    NgbTooltipModule,
    HelpLinkPipe,
    DownloadBuildComponent,
    BrandsModalComponent
  ],
  exports: [DownloadBuildComponent, BrandsModalComponent]
})
export class DownloadBuildModule {}
